<div class="w-full pr-10 flex flex-col gap-6 overflow-hidden">
  <form>
    <div class="bg-white rounded-xl p-4 flex items-center gap-4">
      <div class="flex items-center gap-2 w-full">
        <img src="../../assets/image/search.svg" alt="" class="" />
        <input
          placeholder="Search Concern Type  Here..."
          class="w-full border p-2 rounded-md outline-none"
          placeholder="Search User"
          matInput
          (input)="applyFilter($event)"
        />
      </div>
      <div class="w-80">
        <select
          style="background: #4d4de6"
          class="w-full p-2 outline-none bg-gradient-to-r from-primary to-semiPrimary border rounded-md text-white"
          (change)="filterByStatus($event)"
        >
          <option value="">{{ "all" | translate }}</option>
          <option value="Pending">{{ "pending" | translate }}</option>
          <option value="Verified">{{ "verified" | translate }}</option>
          <option value="Rejected">{{ "rejected" | translate }}</option>
        </select>
      </div>

      <div class="w-60">
        <app-primary-button [routerLink]="'/home/b2'" class="flex w-60">
          <div class="flex space-x-2">
            <img src="../../../../assets/image/+.svg" alt="" />
            <span>{{ "B2" | translate }}</span>
          </div>
        </app-primary-button>
      </div>
    </div>
  </form>
  <div class="bg-white rounded-2xl shadow-md p-4">
    <div class="overflow-auto">
        <table mat-table [dataSource]="dataSource" matSort class="w-full">

      <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column" [ngSwitch]="column">

        <ng-container *ngSwitchCase="'actions'">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let row">
            <button mat-icon-button color="primary" [routerLink]="['/home/docoment-list']">
              <mat-icon>description</mat-icon>
            </button>
          
          </td>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ column }} </th>
          <td mat-cell *matCellDef="let row"> {{ row[column] }} </td>
        </ng-container>

      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    </div>

    <mat-paginator
      [length]="dataSource?.data?.length"
      [pageSize]="10"
      [pageSizeOptions]="[5, 10, 25, 50]"
    >
    </mat-paginator>
  </div>
</div>
